import React from "react";
import MainPagePresenter from "./MainPagePresenter";
import { getAllSchemasUseCase } from "../../usecases/schema/usecases";
import { getCurrentUserUseCase, signOutUseCase } from "../../usecases/user";
import { Routes, Route, useLocation } from "react-router-dom";
import { OffCanvas } from "nq-component";
import CollectionListPage from "../collection-list/CollectionListPage";
import CollectionFormPage from "../collection-form/CollectionFormPage";
import BasePage from "../../base/BasePage";
import NotFoundPage from "../notfound";
import { Layout, Progress, LogoHolder } from "nq-component";
import MigrationPage from "../migration/MigrationPage";
import AccountPage from "../account/AccountPage";
import RoleFormPage from "../role-form/RoleFormPage";
import withRouter from "../../withRouter";
import DashboardPage from "../dashboard/DashboardPage";
import HooksPage from "../web-hook/HooksPage";
import FunctionPage from "../web-hook/FunctionPage";
import SchemaPage from "../schema/SchemaPage";
import SetupPage from "../setup/SetupPage";
import Menus from "./menus.json";
import Menu from "../../components/Menu";
import EmployeeListPage from "../employee/list/EmployeeListPage";
import EmployeeFormPage from "../employee/form/EmployeeFormPage";
import UserListPage from "../user/list/UserListPage";
import JobListPage from "../job-posting/list/JobListPage";
import JobViewPage from "../job-posting/list/components/JobViewPage";
import ResignationListPage from "../Resignation/list/ResignationListPage";
import RequestListPage from "../request/list/RequestListPage";
import ApplicationFormPage from "../application-form/ApplicationFormPage";
import AboutUsPage from "../about-us/AboutUsPage";
import ApplicationStatusList from "../application-status/ApplicationStatusList";
import Navigation from "../../components/Navigation";
import ApplicationStatusForm from "../application-form/ApplicationStatusForm";
import DashboardAppPage from "../dashboardApp/DashboardAppPage";
import WalkInFormPage from "../application-form/walk-in/WalkInFormPage";
import OrientationFormPage from "../application-form/orientation-form/OrientationFormPage";

class MainPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter(
      this,
      getCurrentUserUseCase(),
      signOutUseCase(),
      getAllSchemasUseCase()
    );
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  onClickSignOut() {
    this.presenter.onClickSignOut();
  }

  onClickMenu(e, item) {
    e.preventDefault();
    this.navigateTo(item.route);
  }

  logout() {
    this.presenter.onClickSignOut();
  }

  render() {
    const user = this.getCurrentUser();
    const schemas = this.getSchemas();
    const roles = this.getCurrentRoles();
    if (user === undefined || schemas === undefined) {
      return <Progress />;
    }
    const settings = [
      {
        name: "Edit Account",
        route: "/account",
        icon: "bi bi-person-check",
      },
      {
        name: "Schema",
        route: "/schema",
        icon: "bi bi-filetype-json",
      },
      // {
      //     name: "Notification",
      //     route: "/notification",
      //     icon: "bi bi-bell"
      // },
    ];

    const hook = [
      {
        name: "Hooks",
        route: "/hooks",
        icon: "bi bi-person-check",
      },
      {
        name: "Function",
        route: "/function",
        icon: "bi bi-person-check",
      },
    ];

    const setting = {
      name: "Settings",
      icon: "bi bi-sliders",
      route: settings,
    };

    const hooksMenu = {
      name: "WebHook",
      icon: "bi bi-sliders",
      route: hook,
    };

    function NavigationWrapper({ user, logout }) {
      const location = useLocation();
      const excludedRoutes = [
        "/application-form/walkin_applicants/true",
        "/application-form/walkin_applicants/true#uploadImage",
      ];

      if (excludedRoutes.includes(location.pathname)) {
        return null;
      }

      return <Navigation user={user} logout={logout} />;
    }
    return (
      <Layout>
        <NavigationWrapper user={user} logout={this.logout.bind(this)} />
        <div className="d-flex flex-column">
          <Routes>
            <Route exact path={"/dashboard"} element={<DashboardAppPage />} />
            <Route
              exact
              path={"/collection/:name"}
              element={<CollectionListPage />}
            />
            <Route path={"/roles/form"} element={<RoleFormPage />} />
            <Route path={"/roles/form/:id"} element={<RoleFormPage />} />
            <Route
              path={"/collection/:name/form/"}
              element={<CollectionFormPage />}
            />
            <Route
              path={"/collection/:name/form/:id"}
              element={<CollectionFormPage />}
            />
            <Route path={"/migration"} element={<MigrationPage />} />
            <Route path={"/schema"} element={<SchemaPage />} />
            <Route path={"/account"} element={<AccountPage />} />
            <Route path={"/hooks"} element={<HooksPage />} />
            <Route path={"/function"} element={<FunctionPage />} />
            <Route path={"/setup"} element={<SetupPage />} />
            {/* Admin Side */}
            <Route path={"/admin/employees"} element={<EmployeeListPage />} />
            <Route
              path={"/admin/employee/form"}
              element={<EmployeeFormPage />}
            />
            <Route
              path={"/admin/employees/form/:id"}
              element={<EmployeeFormPage />}
            />
            <Route
              path={"/admin/employees/form/:name/:id"}
              element={<EmployeeFormPage />}
            />
            <Route path={"/admin/users"} element={<UserListPage />} />
            <Route path={"/admin/job-postings"} element={<JobListPage />} />
            <Route
              path={"/admin/job-details/view/:id"}
              element={<JobViewPage />}
            />
            <Route
              path={"/admin/resignation"}
              element={<ResignationListPage />}
            />
            <Route path={"/admin/request"} element={<RequestListPage />} />
            {/*Application Form*/}
            <Route
              path={"/job-list/application-form"}
              element={<ApplicationFormPage />}
            />

            <Route
              path={"/application-status"}
              element={<ApplicationStatusList />}
            />
            <Route
              path={"/application-status/form/:type/:id"}
              element={<ApplicationStatusForm />}
            />
            <Route
              path={"/orientation/form/:type/:id"}
              element={<OrientationFormPage />}
            />
            <Route
              path={"/application-form/walkin_applicants/:isWalkIn"}
              element={<WalkInFormPage />}
            />
            <Route element={<NotFoundPage />} />
          </Routes>
        </div>
      </Layout>
    );
  }
}

export default withRouter(MainPage);
